import React from "react";
import get from "lodash/get";
import { Table } from "antd";
import { Button, Icon } from "antd";
import { Popconfirm } from "antd";

const UserTable = ({ userSet, licenseSet, loading, onDelete, onEdit }) => {
  const licenseSetIndex = licenseSet.reduce(
    (acc, x) => ({ ...acc, [x.id]: x }),
    {}
  );

  const columns = [
    {
      title: "Username",
      dataIndex: "username",
      sorter: (a, b) => a.username.localeCompare(b.username),
    },
    {
      title: "Email",
      dataIndex: "email",
      render: (value) => <a href={`mailto:${value}`}>{value}</a>,
      sorter: (a, b) => a.email.localeCompare(b.email),
    },
    {
      title: "Is admin",
      dataIndex: "isAdmin",
      render: (value) => value && <Icon type="check-circle" />,
      sorter: (a, b) => (a.isAdmin && !b.isAdmin ? 1 : -1),
    },
    {
      title: "License",
      dataIndex: "licenseId",
      render: (value) => get(licenseSetIndex, [value, "name"]),
      sorter: (a, b) => {
        const aName = get(licenseSetIndex, [a.licenseId, "name"], "");
        const bName = get(licenseSetIndex, [b.licenseId, "name"], "");
        return aName.localeCompare(bName);
      },
    },
    {
      title: "Action",
      key: "action",
      render: (row) => (
        <Button.Group size="small">
          <Button onClick={() => onEdit(row)}>
            <Icon type="edit" />
          </Button>
          <Popconfirm
            onConfirm={() => onDelete(row)}
            title="Do you really want to delete this user?"
            okText="Yes"
            cancelText="No"
            placement="left"
          >
            <Button type="danger">
              <Icon type="delete" />
            </Button>
          </Popconfirm>
        </Button.Group>
      ),
    },
  ];
  return (
    <Table
      columns={columns}
      rowKey="id"
      dataSource={userSet}
      size="middle"
      pagination={false}
      bordered={false}
      loading={loading}
    />
  );
};

export default UserTable;
